export default __webpack_public_path__ + "static/media/pes-mobile.3d2a361d.png";